import banking from '../img/icons/AccessibleBanking.png'
import literacy from '../img/icons/ChildrensLiteracy.png'
import crowdfunding from '../img/icons/Crowdfunding.png'
import earth from '../img/icons/earth.png'
import education from '../img/icons/Education.png'
import environment from '../img/icons/Environment.png'
import fairtrade from '../img/icons/FairTrade.png'
import female from '../img/icons/FemaleEmpowerment.png'
import foodsecurity from '../img/icons/FoodSecurity.png'
import foodwaste from '../img/icons/FoodWaste.png'
import healthtech from '../img/icons/HealthTechnology.png'
import humanrights from '../img/icons/HumanRights.png'
import impactinvestment from '../img/icons/ImpactInvestment.png'
import leaf from '../img/icons/leaf.png'
import energy from '../img/icons/SustainableEnergy.png'
import retail from '../img/icons/SustainableRetail.png'
import technnology from '../img/icons/Technology.png'
import volunteering from '../img/icons/Volunteering.png'
import youthservices from '../img/icons/YouthServices.png'

let spectrums = [
    {
        name: 'Accessible Banking',
        icon: banking
    },
    {
        name: 'Literacy',
        icon: literacy
    },
    {
        name: 'Crowdfunding',
        icon: crowdfunding
    },
    {
        name: 'Environment',
        icon: earth
    },
    {
        name: 'Education',
        icon: education
    },
    {
        name: 'Fair Trade',
        icon: fairtrade
    },
    {
        name: 'Female Empowerment',
        icon: female
    },
    {
        name: 'Food Security',
        icon: foodsecurity
    },
    {
        name: 'Food Waste',
        icon: foodwaste
    },
    {
        name: 'Health Technology',
        icon: healthtech
    },
    {
        name: 'Human Rights',
        icon: humanrights
    },
    {
        name: 'Impact Investment',
        icon: impactinvestment
    },
    {
        name: 'Sustainable Energy',
        icon: energy
    },
    {
        name: 'Sustainable Retail',
        icon: retail
    },
    {
        name: 'Technology',
        icon: technnology
    },
    {
        name: 'Volunteering',
        icon: volunteering
    },
    {
        name: 'Youth Services',
        icon: youthservices
    },
    {
        name: 'Sustainability',
        icon: leaf
    },
    {
        name: 'Globalization',
        icon: environment
    }
];

export default spectrums;
